<template>
<e-chart ref="chart" />
</template>

<script>
import {AXIS_LABEL, AXIS_LINE_STYLE, NUMBER_FONT_FAMILY} from './FactorCharts/chartStyle'
export default {
  name: 'ParameterLineChart',
  props: {
    data: {
      required: true,
      type: Object
    }
  },
  methods: {
    render (isReal) {
      let {data, name, unit, min, max, dataTimes} = this.data

      let chartOpt = {
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 10
        },
        legend: {
          width: '80%',
          data: [name]
        },
        tooltip: {
          show: true,
          trigger: 'axis'
        },
        grid: [{
          top: 55,
          right: 20,
          bottom: 50,
          left: 20,
          containLabel: true
        }],
        xAxis: {
          type: 'category',
          data: dataTimes
        },
        yAxis: {
          name: unit,
          type: 'value',
          nameGap: 10,
          axisLine: {
            show: true,
            lineStyle: AXIS_LINE_STYLE
          },
          splitLine: {
            show: true
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: NUMBER_FONT_FAMILY
          }
        },
        dataZoom: [{
          type: 'inside',
          start: 0,
          end: 100,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5
        }, {
          type: 'slider',
          start: 0,
          end: 100,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5,
          // height: 39,
          bottom: 9,
          left: 'center',
          handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
          handleSize: '70%',
          handleStyle: {
            color: '#fff',
            shadowBlur: 4,
            shadowColor: 'rgba(0, 0, 0, 0.15)',
            shadowOffsetX: 2,
            shadowOffsetY: 2
          },
          // dataBackground: {
          //   areaStyle: '#E4F0FF'
          // }
          fillerColor: 'rgba(228, 240, 255, .6)',
          borderColor: '#E4F0FF'
        }],
        series: [{
          name: name,
          type: 'line',
          symbol: 'none',
          data: data
        }, {
          name: '控制线(最高值)',
          type: 'line',
          data: dataTimes.map(el => max),
          color: 'red',
          symbol: 'none',
          lineStyle: {
            type: 'dashed',
            width: 1
          }
        }, {
          name: '控制线(最低值)',
          type: 'line',
          data: dataTimes.map(el => min),
          color: 'red',
          symbol: 'none',
          lineStyle: {
            type: 'dashed',
            width: 1
          }
        }]
      }

      this.$refs.chart.setOpt(chartOpt)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/keylinechart.vue